module.exports = __webpack_public_path__ + "img/face2face_black.a6e40bbb.svg";